import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

//  引入 anychart
import anychart from 'anychart';
Vue.prototype.$anychart = anychart;

// 引入jquery
import $ from "jquery";
// 引入下拉菜单的css
import 'select2/dist/css/select2.css';



// 引入bootstrap 和 图标
import 'bootstrap'
import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.min.js";
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import 'bootstrap-icons/font/bootstrap-icons.css'

// 引用I18n
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const i18n = new VueI18n({
  locale: localStorage.getItem('Language') == null ? 'id' : localStorage.getItem('Language') == 1 ? 'en' : 'id', // 设置默认语言环境
  messages: loadLocaleMessages() // 加载语言环境信息
});

// 引入公共Css 解决被覆盖

import "@/assets/css/style.css";
import "@/assets/css/style4.css";
import "@/assets/css/header.css";
import "@/assets/css/responsive.css";


// 引入公共js
import global from "@/assets/js/global.js";
Vue.prototype._$ = global;
new Vue({
  router,
  store,
  i18n,
  $,
  render: h => h(App)
}).$mount('#app')
